import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ProjectsOverviewPage } from '@/features/projects/projects-overview-page';

export const Route = createFileRoute('/_app/projects/')({
  validateSearch: z.object({
    archived: z.boolean().optional(),
    q: z.string().optional(),
    sort: z
      .enum(['name', 'manager', 'end', 'health', 'progress', 'open', 'overdue', 'activity'])
      .optional(),
    dir: z.enum(['asc', 'desc']).optional(),
    /** D40: cards by default; the table stays one click away. */
    view: z.enum(['grid', 'list']).optional(),
  }),
  component: ProjectsOverviewPage,
});
